import { ADVANCE_DECLINE, ADVANCE_DECLINE_ERROR, ADVANCE_DECLINE_HIDE_ERROR, ADVANCE_DECLINE_START_LOADER, ADVANCE_DECLINE_STOP_LOADER, ADVANCE_DECLINE_STREAM, } from "../interface/iAdvanceDecline";
const initState = {
    data: [],
    loader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
    updatedtime: "",
};
const advanceDecline = (state = initState, action) => {
    switch (action.type) {
        case ADVANCE_DECLINE:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, updatedtime: action.payload.updatedTime });
        case ADVANCE_DECLINE_STREAM:
            return Object.assign(Object.assign({}, state), { data: [action.payload.advDecStream], updatedtime: action.payload.advDecStream.lut });
        case ADVANCE_DECLINE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ADVANCE_DECLINE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case ADVANCE_DECLINE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ADVANCE_DECLINE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default advanceDecline;
